export const httpCustomErrors = {
  errorTitle: 'An error occured',
  passwordReset: 'The password could not be changed.'
};
